// EXPERIMENT: sign_form_signer_carousel_colors_experiment — remove with experiment cleanup
import { createContext } from 'react';

type ReportCarouselSeen = (petitionId: string, signerCount: number) => void;

/** The default no-op keeps the feed renderable without a `SignerCarouselColorsTracking` host. */
export const CarouselSeenContext = createContext<ReportCarouselSeen>(() => {});
